import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitContactForm = async (data) => {
  const response = await axios.post(`${API}/contact`, data);
  return response.data;
};

export const submitQuoteRequest = async (data) => {
  const response = await axios.post(`${API}/quote`, data);
  return response.data;
};

export const submitBooking = async (data) => {
  const response = await axios.post(`${API}/booking`, data);
  return response.data;
};

export const submitApplication = async (formData) => {
  const response = await axios.post(`${API}/careers/apply`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Admin API calls
export const getContacts = async () => {
  const response = await axios.get(`${API}/admin/contacts`);
  return response.data;
};

export const getQuotes = async () => {
  const response = await axios.get(`${API}/admin/quotes`);
  return response.data;
};

export const getBookings = async () => {
  const response = await axios.get(`${API}/admin/bookings`);
  return response.data;
};

export const getApplications = async () => {
  const response = await axios.get(`${API}/admin/applications`);
  return response.data;
};

export const submitReferral = async (data) => {
  const response = await axios.post(`${API}/referral`, data);
  return response.data;
};

export const getReferrals = async () => {
  const response = await axios.get(`${API}/admin/referrals`);
  return response.data;
};
